export function ScoreRing({
  score,
  provisional = false,
  size = "large",
}: {
  score: number;
  provisional?: boolean;
  size?: "large" | "small";
}) {
  const safe = Math.max(0, Math.min(10, score));
  return (
    <div
      className={`score-ring score-ring--${size}`}
      style={{ "--score": `${safe * 10}%` } as React.CSSProperties}
      aria-label={`${provisional ? "Provisional " : ""}score ${safe} out of 10`}
    >
      <div>
        <strong>{safe}</strong>
        <span>/10</span>
        {provisional && <small>provisional</small>}
      </div>
    </div>
  );
}
